import React from "react";
import {Box, Divider, Grid, Typography} from "@mui/material";
import useSystemTheme from "../../../hooks/useSystemTheme";

const TicketDetails = ({details}) => {
    const {isDarkMode} = useSystemTheme();

    function formatDate(isoString) {
        const date = new Date(isoString);

        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');

        return `${year}-${month}-${day} . ${hours}:${minutes}`;
    }

    // Helper function to check if calculation result is NaN
    const calculateRequestPayment = () => {
        const result = details.totalPayment - details.servicePayment;
        return isNaN(result) ? '-' : result;
    };

    const formatPrice = (price) => {
        if (price == null || isNaN(price)) return "-";
        return `KD ${Number(price).toFixed(3)}`;
    };

    const data = [
        {label: "Ticket Number", value: details.ticketNumber || '-'},
        {label: "Key Tag", value: details.keytag || '-'},
        {label: "Parking Location", value: details.branchName || '-'},
        {label: "Parking Block", value: '-'},
        {label: "Checked In", value: details.checkedIn ? formatDate(details.checkedIn) : '-'},
        {label: "Checked Out", value: details.checkedOut ? formatDate(details.checkedOut) : '-'},
        {label: "Customer Phone", value: details.phone || '-'},
        {label: "Valet Payment", value: formatPrice(calculateRequestPayment())},
        {label: "Service Payment", value: formatPrice(details.servicePayment)},
        {label: "Total Payment", value: formatPrice(details.totalPayment)},
        {label: "Payment Option", value: details.paymentMethod ?? '-'},
        {label: "Customer Name", value: details.name || '-'}
    ];

    // Group data into pairs
    const groupedData = [];
    for (let i = 0; i < data.length; i += 2) {
        groupedData.push(data.slice(i, i + 2));
    }

    return (
        <Box
            padding="24px"
            sx={{
                backgroundColor: isDarkMode ? "#000000" : "#FFFFFF",
                borderColor: '#E2E2E2',
                borderWidth: '1px',
                borderStyle: 'solid',
                borderRadius: '24px',
            }}
        >
            <Grid container spacing='8px'>
                {groupedData.map((pair, index) => (
                    <React.Fragment key={index}>
                        <Grid container item xs={12} spacing={2}>
                            <Grid item xs={6}>
                                <Typography
                                    color={isDarkMode ? "#E2E2E2" : "#A9A9A9"}
                                    fontWeight={500}
                                    fontSize={12}
                                    lineHeight='20px'
                                    fontFamily="'Outfit', sans-serif"
                                >
                                    {pair[0].label}
                                </Typography>
                                <Typography
                                    color={isDarkMode ? "#FFFFFF" : "#000000"}
                                    fontWeight={600}
                                    fontSize={12}
                                    lineHeight='30px'
                                    fontFamily="'Outfit', sans-serif"
                                >
                                    {pair[0].value}
                                </Typography>
                            </Grid>
                            {pair[1] && (
                                <Grid item xs={6}>
                                    <Typography
                                        color={isDarkMode ? "#E2E2E2" : "#A9A9A9"}
                                        fontWeight={500}
                                        fontSize={12}
                                        lineHeight='20px'
                                        fontFamily="'Outfit', sans-serif"
                                    >
                                        {pair[1].label}
                                    </Typography>
                                    <Typography
                                        color={isDarkMode ? "#FFFFFF" : "#000000"}
                                        fontWeight={600}
                                        fontSize={12}
                                        lineHeight='30px'
                                        fontFamily="'Outfit', sans-serif"
                                    >
                                        {pair[1].value}
                                    </Typography>
                                </Grid>
                            )}
                        </Grid>
                        {index !== groupedData.length - 1 && (
                            <Grid item xs={12}>
                                <Divider sx={{my: 1, bgcolor: '#EBEBEB'}}/>
                            </Grid>
                        )}
                    </React.Fragment>
                ))}
            </Grid>
        </Box>
    );
};

export default TicketDetails;